module.exports = __webpack_public_path__ + "static/img/sh2.59f77e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sh2.svg
// module id = sujX
// module chunks = 1